import { number, shape, string } from 'prop-types'

import PriceInfoES_v1 from './PriceInfoES_v1'

export default {
  amount: number,
  currency: string,
  net: number,
  info: shape(PriceInfoES_v1),
}
